/* eslint-disable no-underscore-dangle */

import join from 'lodash/join';
import forEach from 'lodash/forEach';

import fetch from './fetch';

const queryString = (params = {}) => {
    const encoded = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
    return encoded ? `?${encoded}` : encoded;
};

export class Endpoint {
    path = null;
    csrfToken = null;

    constructor(path, csrfToken) {
        this.path = path;
        this.csrfToken = csrfToken;
    }

    _fetch = ({path, method, successStatus, data, filters}) => new Promise((resolve, reject) => {
        const options = {
            method,
            credentials: 'same-origin',
            headers: {
                'X-CSRFToken': this.csrfToken,
            },
        };

        if (data) {
            options.body = data;

            if (typeof data === 'string') options.headers['Content-Type'] = 'application/json';
        }

        const filterQuery = queryString(filters);

        const handleResponse = response => {
            const {status} = response;

            if (status === successStatus) return status === 204 ? {} : response.json();

            throw new Error(`[ReSourceAPI] ${method} ${path}. Invalid response status: ${status}`);
        };

        return fetch(`${path}${filterQuery}`, options).then(handleResponse).then(resolve).catch(reject);
    });

    _detailFetch = ({id, ...props}) => {
        const path = this._detailPath(id);
        return this._fetch({path, ...props});
    };

    _detailPath = id => {
        const idPath = id instanceof Array ? join(id, '/') : id;
        return `${this.path}/${idPath}`;
    };

    list = ({...filters}) => this._fetch({
        path: this.path,
        method: 'GET',
        successStatus: 200,
        filters,
    });

    retrieve = id => this._detailFetch({
        id,
        method: 'GET',
        successStatus: 200,
    });

    create = data => this._fetch({
        path: this.path,
        method: 'POST',
        successStatus: 201,
        data,
    });

    createWithCustomSuccess = (data, successStatus) => this._fetch({
        path: this.path,
        method: 'POST',
        successStatus: successStatus,
        data,
    });

    update = (id, data) => this._detailFetch({
        id,
        method: 'PATCH',
        successStatus: 200,
        data,
    });

    replace = data => this._fetch({
        path: this.path,
        method: 'PUT',
        successStatus: 201,
        data,
    });

    replaceWithCustomSuccess = (data, successStatus) => this._fetch({
        path: this.path,
        method: 'PUT',
        successStatus: successStatus,
        data,
    });

    destroy = id => this._detailFetch({
        id,
        method: 'DELETE',
        successStatus: 204,
    });
}


class API {
    constructor(csrfToken) {
        this.csrfToken = csrfToken;

        const {Endpoints, BaseURL} = this.constructor;

        forEach(Endpoints, (value, field) => {
            this[field] = new Endpoint(
                `${BaseURL}${value}`,
                csrfToken,
            );
        });
    }
}


class ReSourceAPI extends API {

    static BaseURL = '/api/v1/';

    static Endpoints = {
        appointment: 'appointment',
        dyadPreferences: 'dyad-preferences',
        logs: 'logs',
        media: 'media',
        meditation: 'meditation',
        questionnaire: 'questionnaire',
        samplings: 'samplings',
        timeslot: 'timeslot',
        user: 'user',
        pairings: 'pairings',
        predefinedChatMessages: 'contact-phrases'
    };
}

export class EsnapsAPI extends API {
    static BaseURL = '/esnap/';

    static Endpoints = {
        activeEsnaps: 'esnap-events',
    };
}

export class DashboardAPI extends API {
    static BaseURL = '/dashboard/api/v1/';

    static Endpoints = {
        pairings: 'pairings',
    };
}

export default ReSourceAPI;



// WEBPACK FOOTER //
// ./scripts/utils/api.js